import { render, staticRenderFns } from "./LockAccountButton.vue?vue&type=template&id=9078b004&"
import script from "./LockAccountButton.vue?vue&type=script&lang=js&"
export * from "./LockAccountButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports